import { render, staticRenderFns } from "./SoccerScoresMatchStatus.vue?vue&type=template&id=d442a202&"
import script from "./SoccerScoresMatchStatus.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresMatchStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports